export const CONTAINER_CLASS = "container-class";
export const CAM_DROPDOWN_CLASS = "cam-drop-down";
export const SPEAKER_BUTTON_CLASS = "speaker-button";
export const CAM_ELEMENT = "camElement";
export const CAM_VIEW_DESKTOP_CONTAINER = "camview-desktop-container";
export const CAM_MOBILE_TOP_SECTION = "cam-mobile-top-section";
export const AUDIO_TEST_DISCONNECTED = "audio-test-disconnected";
export const AUDIO_TEST_VIEW = "audio-test-view";
export const POPUP_TITLE_CLASS = "devicechecker-popup-title";
